export default __webpack_public_path__ + "static/media/newspaper-clipping.096720cc.svg";